import { TUser } from '../../types/currentUser';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EUserActionTypes {
  SetUser = 'user/set',
}

export type TSetUser = ITypedReduxAction<EUserActionTypes.SetUser, TUser>;

export const setUser: (user: TUser) => TSetUser = actionGenerator<EUserActionTypes.SetUser, TUser>(
  EUserActionTypes.SetUser,
);
